var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscren"},[_c('Icon',{attrs:{"type":_vm.fullScren == true ? 'ios-contract' : 'ios-expand',"color":"#97a8be","size":"18"},on:{"click":_vm.handleScreen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }